<template>
  <Tag :value="statusConfig.label" :class="statusConfig.class" :severity="statusConfig.severity">
    <span :class="[statusConfig.icon, 'mr-1']"></span>
    {{ statusConfig.label }}
  </Tag>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const statusMap = {
  ongoing: {
    label: t(`enums.YOUSIGN_ONGOING`, 'ongoing'),
    icon: 'mdi mdi-signature',
    severity: 'success',
    class: 'status-ongoing',
  },
  done: {
    label: t(`enums.YOUSIGN_DONE`, 'signed'),
    icon: 'mdi mdi-draw-pen',
    severity: 'success',
    class: 'status-done',
  },
};

interface YousigntatusBadgeProps {
  status: 'ongoing' | 'done' | string;
}

const props = defineProps<YousigntatusBadgeProps>();
const statusConfig = computed(() => {
  const normalizedStatus = props.status.toLowerCase();
  const matchedKey = Object.keys(statusMap).find((key) => key.toLowerCase() === normalizedStatus);

  return matchedKey
    ? statusMap[matchedKey as keyof typeof statusMap]
    : {
        label: props.status,
        icon: 'pi pi-question-circle',
        severity: 'secondary',
        class: 'status-unknown',
      };
});
</script>

<style scoped lang="css">
@config "../../../../tailwind.config.js";
@reference "tailwindcss";

/* gemeinsames Badge-Layout */
.status-badge {
  @apply flex items-center gap-1 px-2 py-1;
}

/* States – nur Utilities, kein theme() */
.status-ongoing {
  @apply text-interactiongreen-500 border border-interactiongreen-500 bg-transparent;
}

.status-done {
  @apply text-white border bg-interactiongreen-500 border-interactiongreen-500;
}
</style>
